import { useEffect, useState } from 'react';
import { Card, Container, Row, Col } from 'react-bootstrap';
import DocumentMeta from 'react-document-meta';
import axios from 'axios';

import CommunityArticles from '../components/CommunityArticle';

import config from '../config';

const meta = {
  title: 'Who are Community Providers? | Free medication abortion',
  description: '',
  meta: {
    charset: 'utf-8',
    name: {
      keywords: '',
    },
    property: {
      'og:title': 'Who are Community Providers? | Free medication abortion',
      'og:description': '',
      'og:image': '',
    },
  },
};

export default function CommunityProviders() {
  const [cmsData, setCmsData] = useState(undefined);
  const [providers, setProviders] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${config.contentBaseUrl}/content/item/wrcp`,
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        if (result._id) {
          console.log(result);
          setCmsData(result);
        }
      } catch (error) {
        console.log(error.message);
      } finally {
        //
      }
    };

    const fetchProviders = async () => {
      try {
        const providersReq = await axios.get(
          `${config.contentBaseUrl}/content/items/CP?sort={"_created":1}`,
        );
        setProviders(providersReq.data);
      } catch (err) {
        console.log(err);
      } finally {
        //
      }
    };

    fetchData();
    fetchProviders();
  }, []);

  return (
    <DocumentMeta {...meta}>
      <div className="about-page">
        <div className="page-title dark-background text-start contact-bg">
          <div className="container position-relative">
            {cmsData && <h1>{cmsData.title || ''}</h1>}
          </div>
        </div>

        <section className="about section light-background py-4">
          <div className="container section-title pb-0">
            {cmsData && (
              <div
                className="col-lg-12 cms-content content section-title pb-3"
                dangerouslySetInnerHTML={{ __html: cmsData.content || '' }}
              ></div>
            )}
          </div>
        </section>

        <section className="py-5 light-background">
          <Container>
            <h3 className="mb-4">
              Community Providers are listed as informational resources on:
            </h3>
            <Row className="g-4">
              {providers.map(({ name, url }, idx) => (
                <Col md={6} lg={4} key={idx}>
                  <Card className="h-100 provider-card shadow-sm p-2 border-0">
                    <Card.Body>
                      <Card.Title className="fw-normal">
                        <a
                          href={url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-decoration-none"
                        >
                          {name}
                        </a>
                      </Card.Title>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <CommunityArticles />
      </div>
    </DocumentMeta>
  );
}
